export const RULES = "rules";
export const RULES_DEEMED_SUPPLIER = "rulesDeemedSupplier";
